/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { urls } from '../../core/utils/constants';
import SignUpForm from './SignUpForm';

class SignUp extends Component {
  render() {
    const { user } = this.props;

    if (user) {
      return (
        <Redirect to={urls.root.path} />
      );
    }
    return (
      <SignUpForm />
    );
  }
}

SignUp.propTypes = {
  user: PropTypes.shape().isRequired,
};

export default withRouter(SignUp);
